import {Box} from '@mui/material';

import {clampPercentage} from '../utils/matchScoreUtils';

import {orangeColors} from '../../../../../layouts/theme/designSystem';

type Props = {
  score: number | null | undefined;
  barFill: string;
};

export const MatchTotalBar = ({score, barFill}: Props) => {
  const pct = clampPercentage(score);

  return (
    <Box
      sx={{
        width: 52,
        height: 6,
        bgcolor: orangeColors[5],
        borderRadius: '2px',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: `${pct}%`,
          bgcolor: barFill,
          borderRadius: '2px',
        }}
      />
    </Box>
  );
};
